module.exports = __webpack_public_path__ + "static/media/skopei-360-only.61ded0c5.svg";